import {GET_LENDERS_FOR_VERTICAL} from '../components/lenders-text'
import {useQuery} from '@apollo/client'

const useActiveLenders = (vertical, loanPurpose, provideFullResults) => {
  const {error, loading, data} = useQuery(GET_LENDERS_FOR_VERTICAL, {
    variables: {vertical, loanPurpose}
  })

  if (provideFullResults) {
    return {error, loading, data}
  }

  return data ? data.getLendersForVertical : []
}

export default useActiveLenders
